import { useAuthentication } from '@givebacks/api';
import { IfFeatureState_Core } from 'core';
import { PagesUrl } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { Divider, NavLink, Stack } from 'ui';
import { IconHome, IconReceipt, IconRewardsSimple, IconSearch, IconUser } from 'ui/Icons';

import classes from './MobileMenuLinks.module.css';

const AuthenticatedMenuLinks = () => {
  const { logOut } = useAuthentication();

  return (
    <Stack gap={4} p="sm">
      <Divider />
      <NavLink
        label="Sign Out"
        classNames={classes}
        onClick={() => {
          void logOut();
        }}
      />
    </Stack>
  );
};

const MobileMenuLinks = () => {
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  return (
    <Stack gap={4}>
      <NavLink
        label={'Home'}
        leftSection={<IconHome />}
        classNames={classes}
        onClick={() => {
          navigate('home');
        }}
      />

      <IfFeatureState_Core featureId="user.studentFees">
        <NavLink
          label={'Fees'}
          leftSection={<IconReceipt />}
          classNames={classes}
          onClick={() => {
            navigate('/student-fees');
          }}
        />
      </IfFeatureState_Core>

      <NavLink
        label={'Search'}
        leftSection={<IconSearch />}
        classNames={classes}
        onClick={() => {
          navigate('causes');
        }}
      />

      <NavLink
        label={'Rewards'}
        leftSection={<IconRewardsSimple />}
        classNames={classes}
        onClick={() => {
          navigate('rewards');
        }}
      />

      {isAuthenticated && (
        <NavLink
          label="Account"
          leftSection={<IconUser />}
          classNames={classes}
          onClick={() => {
            navigate(PagesUrl.ACCOUNT);
          }
      }
          />
      )}
    </Stack>
  );
};

export { AuthenticatedMenuLinks, MobileMenuLinks };
